var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoursquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9354 4.88803L16.4563 7.2012C16.4016 7.44757 16.1689 7.66657 15.8815 7.66657H11.7205C11.2551 7.66657 10.8719 8.04981 10.8719 8.51518V9.02162C10.8719 9.48699 11.2551 9.87023 11.7205 9.87023H15.2381C15.5666 9.87023 15.8404 10.185 15.772 10.5272C15.7035 10.8831 15.334 12.6898 15.2929 12.8815C15.2655 13.0868 15.0465 13.3468 14.718 13.3468H11.8437C11.2414 13.3605 11.1183 13.3742 10.7624 13.8122C10.4065 14.2502 7.25841 18.1922 7.25841 18.1922C7.23104 18.2332 7.20367 18.2195 7.20367 18.1785V4.77853C7.20367 4.46373 7.46373 4.20367 7.77853 4.20367H16.4153C16.7164 4.20367 17.0175 4.50479 16.9354 4.88803ZM17.565 2C17.565 2 8.38078 2 6.90254 2C5.438 2 5 3.10868 5 3.80673V20.7517C5 21.5866 5.42431 21.833 5.65699 21.9288C5.88968 22.0246 6.50561 22.093 6.94361 21.6551C6.94361 21.6551 12.0079 15.7558 12.0901 15.66C12.1722 15.5642 12.2132 15.5642 12.268 15.5642C12.3227 15.5642 14.4169 15.5642 15.4708 15.5642C16.8396 15.5642 17.0996 14.6197 17.2502 14.0449C17.3734 13.5658 18.7832 6.72214 19.2212 4.55954C19.5497 2.88968 19.1254 2 17.565 2Z",
    fill: "#FA4778"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoursquare);
export default __webpack_public_path__ + "static/media/foursquare.6cf2711bae3abbe5f77b467c1f617ef5.svg";
export { ForwardRef as ReactComponent };